import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { StorageMap } from "@ngx-pwa/local-storage";
import { QuoteRequest } from "app/shared/models/domain/data.model";
import { SearchOptionRequest } from "app/shared/models/request/search-option-request.model";
import { PageResponse } from "app/shared/models/response/page-response.model";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuditListView, CustomerAuditListView } from "../audits/models/audit-list-view.model";
import { DashboardCustomerQuoteRequest, DashboardSalesQuoteRequest } from "./roles/dashboard-customer/dashboard-customer.types";
import { DashboardSalesManagerView } from "./roles/dashboard-sales-manager/dashboad-sales-manager.types";
import { ClientCertificateView } from "app/shared/models/view/client-certificate-view.model";

@Injectable({
    providedIn: 'root'
})
export class DashboardService {
    baseUrl = environment.apiBaseUrl;
    httpOptions: any = {
        withCredentials: true,
        observe: 'response' as 'response'
    };
    private requestKey: string = "application-filter";
    constructor(
        private _httpClient: HttpClient,
        private storage: StorageMap
    ) {
    }

    private _isoDashboardTabIndexName: string = 'isoDashboardTabIndex';

    private sortMap: any = {
        created: 'createdDate',
        createdDateCustom: 'created',
    };

    set tabIndex(idx: number) {
        var val: string = (idx >= 0 && idx !== null) ? idx.toString() : null;

        localStorage.setItem(this._isoDashboardTabIndexName, val);
    }

    get tabIndex(): number {
        var val: string = localStorage.getItem(this._isoDashboardTabIndexName);

        if (val) {
            return parseInt(val);
        }

        return 0;
    }

    getParams(request, params): any {
        params['itemsPerPage'] = request.itemsPerPage?.toString();
        params['currentPage'] = request.currentPage?.toString();

        if (request.sort && request.sortDir) {

            if (Object.keys(this.sortMap).indexOf(request.sort) > -1) {
                params[`sort[${this.sortMap[request.sort]}]`] = request.sortDir;
            }
            else {
                params[`sort[${request.sort}]`] = request.sortDir;
            }
        }

        if (request.priorityClient && request.priorityClient != 2) {
            params['find[priorityClient]'] = request.priorityClient;
        } else if (request.priorityClient == 2) {
            params['find[priorityClient]'] = 0;
        }

        if (request.salesRep) {
            params['orLike[assignedToUserId]'] = parseInt(request.salesRep);
        }

        if (request.requestStatus) {
            params['find[requestStatus]'] = request.requestStatus;
        }

        if (request.auditStatus && request.auditStatus?.length) {
            params['find[auditStatus:in]'] = request.auditStatus?.join();
        }

        if (request.clientID) {
            params['orLike[clientId]'] = request.clientID;
            params['orLike[clientID]'] = request.clientID;
        }

        if (request.clientIdTemp) {
            params['orLike[clientID]'] = request.clientIdTemp;
        }

        if (request.clientId) {
            params['orLike[clientId]'] = request.clientId;
            params['orLike[clientID]'] = request.clientId;
        }

        if (request.userID && request.userID > 0) {
            params['find[userID]'] = request.userID;
        }

        if (request.deleted == false) {
            params['find[deleteFlag]'] = 0;
        }

        if (request.assignedToUserId) {
            params['orLike[assignedToUserId]'] = request.assignedToUserId;
            params['orLike[assignedByUserId]'] = request.assignedToUserId;
            params['orLike[createdByUserId]'] = request.assignedToUserId;
        }

        if (request.showUnassignedOnly && request.showUnassignedOnly !== '') {
            params['find[assignedTo]'] = '';
        }

        if (request.query) {
            params['find[companyName]'] = request.query;
        }

        return params;
    }

    getSalesRepOptions(): Observable<SearchOptionRequest[]> {
        return this._httpClient.get<any>(`${this.baseUrl}api/data/sales-rep-view?currentPage=1&itemsPerPage=100`)
            .pipe(map((data) => {
                return data.items.map((item) => {
                    return {
                        label: item.firstName + ' ' + item.lastName
                        , value: item.salesRepID
                    } as SearchOptionRequest;
                })
            }));
    }

    getSalesManagerQuoteRequests(request): Observable<PageResponse<DashboardSalesManagerView>> {
        let params = {};
        params = this.getParams(request, params);

        return this._httpClient.get<any>(`${this.baseUrl}api/data/dashboard/sales-manager`, { params: params })
            .pipe(map((data) => {
                return data as PageResponse<DashboardSalesManagerView>;
            }));
    }

    getAdminQuoteRequest(requestId: string): Observable<QuoteRequest> {
        return this._httpClient.get<any>(`${this.baseUrl}api/data/admin/quote-request/${requestId}`)
            .pipe(map((data) => {
                return data.item as QuoteRequest;
            }));
    }
    updateAssignToQuoteRequest(param: QuoteRequest): Observable<QuoteRequest> {
        return this._httpClient.put<any>(`${this.baseUrl}api/data/admin/quote-request/${param.id}`, param)
            .pipe(map((data) => {
                return data.item as QuoteRequest;
            }));
    };

    getSalesRepQuoteReuqests(request): Observable<PageResponse<DashboardSalesManagerView>> {
        let params = {};
        params = this.getParams(request, params);

        return this._httpClient.get<any>(`${this.baseUrl}api/data/dashboard/sales-rep`, { params: params })
            .pipe(map((data) => {
                return data as PageResponse<DashboardSalesManagerView>;
            }));
    }

    getCustomerQuoteRequests(request): Observable<any> {
        let params = {};
        params = this.getParams(request, params);
        return this._httpClient.get<any>(`${this.baseUrl}api/data/user/quote-request`, {
            params: params
        }).pipe(map((data) => {
            const returnData = data;
            returnData.items = data.items?.map((item) => {

                if (request.allData) {
                    return {
                        id: item.id
                        , companyName: item.companyName
                        , companyLocation: `${item.companyAddress1} ${item.companyCity}, ${item.companyState} ${item.companyPostCode} ${item.companyCountry}`
                        , requestStatus: item.requestStatus
                        , standards: null
                        , createdDate: item.created
                        , ...item
                    } as DashboardCustomerQuoteRequest;
                }
                return {
                    id: item.id
                    , companyName: item.companyName
                    , companyLocation: `${item.companyAddress1} ${item.companyCity}, ${item.companyState} ${item.companyPostCode} ${item.companyCountry}`
                    , requestStatus: item.requestStatus
                    , standards: null
                    , createdDate: item.created
                } as DashboardCustomerQuoteRequest;
            });
            return returnData;
        }));
    }


    getCustomerQuoteRequestsView(request): Observable<any> {
        let params = {};
        params = this.getParams(request, params);
        return this._httpClient.get<any>(`${this.baseUrl}api/data/user/quote-request-view`, {
            params: params
        }).pipe(map((data) => {
            const returnData = data;
            returnData.items = data.items?.map((item) => {

                if (request.allData) {
                    return {
                        id: item.id
                        , companyName: item.companyName
                        , companyLocation: `${item.companyAddress1} ${item.companyCity}, ${item.companyState} ${item.companyPostCode} ${item.companyCountry}`
                        , requestStatus: item.requestStatus
                        , standards: item?.standards
                        , createdDate: item.created
                        , ...item
                    } as DashboardCustomerQuoteRequest;
                }
                return {
                    id: item.id
                    , companyName: item.companyName
                    , companyLocation: `${item.companyAddress1} ${item.companyCity}, ${item.companyState} ${item.companyPostCode} ${item.companyCountry}`
                    , requestStatus: item.requestStatus
                    , standards: item?.standards
                    , createdDate: item.created
                } as DashboardCustomerQuoteRequest;
            });
            return returnData;
        }));
    }

    getCustomerClientsView(request): Observable<any> {
        let params = {};
        params = this.getParams(request, params);
        return this._httpClient.get<any>(`${this.baseUrl}api/data/customer/clients-view`, {
            params: params
        }).pipe(map((data) => {
            return data;
        }));
    }

    getClientById(request): Observable<any> {
        let params = {};
        params = this.getParams(request, params);
        return this._httpClient.get<any>(`${this.baseUrl}api/data/customer/clients-view`, {
            params: params
        }).pipe(map((data) => {
            return data;
        }));
    }

    getSalesQuoteRequests(request): Observable<any> {
        let params = {};
        params = this.getParams(request, params);
        return this._httpClient.get<any>(`${this.baseUrl}api/data/customer/view/sales-quote`, {
            params: params
        }).pipe(map((data) => {

            const returnData = data;
            returnData.items = data.items?.map((item) => {

                return {
                    quoteId: item.id
                    , quoteRequestId: item.quoteRequestId
                    , title: item.title
                    , company: item.client
                    , standards: item.standardName
                    , totalDays: item.totalDays
                    , totalCost: item.totalCost
                    , quoteStatus: item.quoteStatus
                    , createdDate: item.createdDate
                    , standardName: item?.standardName
                    , revisionComment: item?.revisionComment
                } as DashboardSalesQuoteRequest
            });
            return returnData;
        }));
    }

    getCustomerCertificate(request): Observable<any> {
        let params = {};
        params = this.getParams(request, params);
        return this._httpClient.get<any>(`${this.baseUrl}api/data/customer/certificate-view`,{
            params:params
        }).pipe(map((data)=>{
            const returnData = data;
            returnData.items = data.items?.map((items)=>{
                return{
                    certificateID: items.certificateID,
                    standardID: items.standardID,
                    standard: items.standard,
                    certificate: items.certificate,
                    certificateNumber: items.certificateNumber,
                    approvalDate: items.approvalDate,
                    revisionDate: items.revisionDate,
                    certificateDate: items.certificateDate,
                    expiryDate: items.expiryDate,
                    certificateStatusID: items.certificateStatusID,
                    status: items.status,
                    active: items.active,
                    mediaID: items.mediaID,
                    ballotID: items.ballotID,
                    url: items.url
                } as ClientCertificateView
            })
        }));
    }




    getUserActivities(request): Observable<any> {
        let params = {};
        params = this.getParams(request, params);
        return this._httpClient.get<any>(`${this.baseUrl}api/data/user/activities`, {
            params: params
        }).pipe(map((data) => {
            return data;
        }));
    }


    getAudits(request): Observable<any> {
        let params = {};
        params = this.getParams(request, params);
        return this._httpClient.get<any>(`${this.baseUrl}api/data/auditor/audit`, { params: params }).pipe(map((data) => {
            // return data;
            const returnData = data;
            returnData.items = data.items?.map((rows) => {
                return {
                    //  DO NOT CHANGE THE ORDER OF THE COLUMNS
                    'auditID': rows.auditID,
                    'auditNumber': rows.auditID,
                    'auditType': rows['auditType'],
                    'clientName': rows['clientName*'],
                    'auditStatus': rows['auditStatus*'],
                    'dropDeadDate': rows['dropDeadDate'],
                    'startDate': rows['startDate*'],
                    'endDate': rows['endDate*'],
                };
            });
            return returnData;
        }));
    }

    getCustomerAudits(request): Observable<any> {
        let params = {};
        params = this.getParams(request, params);
        return this._httpClient.get<PageResponse<CustomerAuditListView>>(`${this.baseUrl}api/data/customer/audit-list-view`, { params: params })
            .pipe(map((audits: any) => {
                audits.items = audits.items.map((rows: any) => {

                    return {
                        'clientName': rows['clientName*'],
                        'auditStatus': rows['auditStatus*'],
                        'auditNumber': rows.auditNumber,
                        'auditID': rows.auditNumber,
                        'clientId': rows.clientID,
                        'standard': rows?.standard,
                        'standardID': rows?.standardID,
                        'auditType': rows['auditType'],
                        'dropDeadDate': rows['dropDeadDate'],
                        'startDate': rows['startDate*'],
                        'endDate': rows['endDate*'],
                        'auditStartDate': rows['startDate'] ?? rows['startDate*'],
                        'auditEndDate': rows['endDate'] ?? rows['endDate*'],
                    };
                });
                return audits;
            }));
    }
}
